import React from 'react';

function SuccessPopup({ message, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="success-popup" onClick={(e) => e.stopPropagation()}>
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="36" fill="#4caf50" />
            <path d="M28 40 L36 48 L52 32" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className="success-title">Success!</h2>
        <p className="success-message">{message}</p>
        <button className="success-btn" onClick={onClose}>OK</button>
      </div>
    </div>
  );
}

export default SuccessPopup;
